import { render, staticRenderFns } from "./TheBasket.vue?vue&type=template&id=6c6499b2"
import script from "./TheBasket.vue?vue&type=script&lang=js"
export * from "./TheBasket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports